import { render, staticRenderFns } from "./peaFinancialSummary.vue?vue&type=template&id=04a10118&scoped=true"
import script from "./peaFinancialSummary.vue?vue&type=script&lang=js"
export * from "./peaFinancialSummary.vue?vue&type=script&lang=js"
import style0 from "./peaFinancialSummary.vue?vue&type=style&index=0&id=04a10118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a10118",
  null
  
)

export default component.exports